import { useMutation } from "@tanstack/react-query"

import { queryClient } from "@/services/tanstackQuery/queryClient"

import { trpcOptions } from "../trpc"

export function useFinishSession(sessionId: string) {
  return useMutation(
    trpcOptions.app.finishSession.mutationOptions({
      onSuccess: () => {
        queryClient.setQueryData(trpcOptions.app.getSessionDetail.queryKey({ sessionId }), (old) =>
          old ? { ...old, finished: true } : old,
        )
        return queryClient.invalidateQueries(trpcOptions.app.getSessionDetail.queryFilter({ sessionId }))
      },
    }),
  )
}
